export default __webpack_public_path__ + "static/media/hands2.c237bddd.jpg";